import { LABEL } from "@veriables";

export const HeaderButtons = [
  {
    name: LABEL().OPEN_SCAN,
    key: 'scan',
  },
  {
    name: LABEL().OPEN_TABLE,
    key: 'table',
  },
  {
    name: LABEL().OPEN_TAB,
    key: 'tab',
  },
  {
    // name: LABEL().OPEN_OTHER,
    name: LABEL().TG_TOGO,
    key: 'togo',
  },
  {
    name: LABEL().COUNTER_NEW_ORDER,
    key: 'counter',
  },
  {
    name: LABEL().SPEED_ORDER,
    key: 'speedOrder',
  },
];
